﻿(() => {
  const buttons = ['sts-download-button', 'sts-download-button-bottom']
    .map((id) => document.getElementById(id)).filter(Boolean);
  const choices = document.getElementById('sts-store-choices');
  if (!buttons.length || !choices) return;

  const apple = 'https://apps.apple.com/us/app/setting-the-space/id6805828147';
  const google = 'https://play.google.com/store/apps/details?id=com.settingthespace.app';
  const android = /Android/i.test(navigator.userAgent);
  const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    || (/Macintosh|MacIntel/i.test(navigator.userAgent + ' ' + navigator.platform)
      && navigator.maxTouchPoints > 1);
  const destination = android ? google : ios ? apple : null;
  if (destination) {
    buttons.forEach((button) => { button.href = destination; });
    return;
  }

  const script = document.getElementById('sts-app-download-script');
  const badges = [
    [script.dataset.appleBadge, 'Download on the App Store', 'sts-store-badge--apple', 144, 48],
    [script.dataset.googleBadge, 'Get it on Google Play', 'sts-store-badge--google', 186, 72]
  ];
  buttons.forEach((button) => {
    const group = document.createElement('div');
    group.className = 'sts-desktop-download';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', "Choose your phone's app store");
    const label = document.createElement('p');
    label.className = 'sts-desktop-download__label';
    label.textContent = 'Choose your phone’s app store.';
    const row = document.createElement('div');
    row.className = 'sts-desktop-download__badges';
    badges.forEach(([src, alt, className, width, height], index) => {
      const link = document.createElement('a');
      Object.assign(link, { href: index === 0 ? apple : google, target: '_blank', rel: 'noopener' });
      const image = document.createElement('img');
      Object.assign(image, { src, alt, className, width, height });
      link.append(image);
      row.append(link);
    });
    group.append(label, row);
    button.replaceWith(group);
  });
  choices.hidden = true;
  document.querySelector('.sts-app-page').classList.add('sts-app-page--desktop');
})();
